import { useMemo } from 'react'
import { useImmeubleReliability } from './useReliability'
import { useLots } from './useLots'
import { useSpaces } from './useSpaces'

/**
 * Cross-section aggregated pending count (spec §9) — the sum of every
 * section's own count. Shared by DataReliabilityTab's in-body counter and
 * the "Data" tab's nav-entry badge (AssetDetailPage), so both always agree
 * and there is exactly one place computing this sum. TanStack Query dedupes
 * the underlying requests across both call sites.
 */
export function useAggregatedReliabilityCount(org: string, assetUid: string, locale: string) {
  const { changes } = useImmeubleReliability(org, assetUid, locale)
  const { lots } = useLots(org, assetUid)
  const { spaces: commonSpaces } = useSpaces(org, assetUid, 'common')
  const { spaces: exteriorSpaces } = useSpaces(org, assetUid, 'exterior')

  return useMemo(() => {
    const lotsToReview = lots.filter((l) => l.pending).length
    const commonToReview = commonSpaces.filter((s) => s.pending).length
    const exteriorToReview = exteriorSpaces.filter((s) => s.pending).length
    return changes.length + lotsToReview + commonToReview + exteriorToReview
  }, [changes.length, lots, commonSpaces, exteriorSpaces])
}
